module.exports = __webpack_public_path__ + "images/compass__arrow-b2da2d.svg";